import { jsxs as t, jsx as o } from "react/jsx-runtime";
import f, { useCallback as O } from "react";
import { Button as y } from "./index26.mjs";
import { useMediaQuery as E, Stack as m } from "@mui/material";
import { useStennTheme as $ } from "./useStennTheme.mjs";
import { Chip as g } from "./index90.mjs";
import { MOBILE_SMALL_SCREEN as n } from "./screens.mjs";
import { StyledAlertCard as w, AlertCardIconWrapper as I, AlertCardTitle as L, AlertCardChildren as M, AlertCardActionWrapper as P } from "./styles.mjs";
import { STATE_TO_CHIP_COLOR_MAPPING as R, STATE_TO_BUTTON_COLOR_MAPPING as C } from "./constants8.mjs";
import { updateChildrenRecursively as k } from "./updateChildrenRecursively.mjs";
const U = ({
  testId: A,
  label: p,
  icon: s,
  title: c = "",
  children: d,
  actions: _,
  renderActions: u,
  variant: e = "outlined",
  state: r = "primary",
  className: h,
  sx: T
}) => {
  const { breakpoints: x } = $(), l = E(x.down(n)), S = O(
    (a) => k(a, (i) => f.isValidElement(i) && i.type === y ? f.cloneElement(i, {
      ...i.props,
      size: l ? "medium" : "small",
      color: C[r]
    }) : i),
    [l, r]
  );
  return /* @__PURE__ */ t(
    w,
    {
      $state: r,
      $variant: e,
      "data-testid": A,
      className: h,
      sx: T,
      children: [
        /* @__PURE__ */ t(m, { direction: "column", gap: 0.5, children: [
          /* @__PURE__ */ t(
            m,
            {
              direction: "row",
              gap: 1,
              sx: { flexWrap: { xs: "wrap", [n]: "nowrap" } },
              children: [
                p && /* @__PURE__ */ o(
                  g,
                  {
                    label: p,
                    color: R[r],
                    variant: e === "solid" ? "outlined" : "primary",
                    size: "small",
                    sx: (a) => ({
                      marginTop: a.spacing(0.3)
                    })
                  }
                ),
                (s || c) && /* @__PURE__ */ t(
                  m,
                  {
                    direction: "row",
                    alignItems: "flex-start",
                    gap: 1,
                    sx: { width: { xs: "100%", [n]: "auto" } },
                    children: [
                      /* @__PURE__ */ o(I, { $state: r, $variant: e, children: s }),
                      /* @__PURE__ */ o(L, { $state: r, $variant: e, children: c })
                    ]
                  }
                )
              ]
            }
          ),
          d && /* @__PURE__ */ o(M, { $variant: e, children: d })
        ] }),
        /* @__PURE__ */ o(P, { children: typeof u == "function" ? u({
          size: l ? "medium" : "small",
          color: C[r]
        }) : S(_) })
      ]
    }
  );
};
export {
  U as AlertCard
};
//# sourceMappingURL=index2.mjs.map
